module.exports = __webpack_public_path__ + "static/media/customer.60bf8ffd.png";